import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Nosotros from "../pages/nosotros/page";
import AdminLogin from "../pages/admin/login/page";
import Admin from "../pages/admin/page";
import Dashboard from "../pages/admin/dashboard/page";
import Sales from "../pages/admin/sales/page";
import Expenses from "../pages/admin/expenses/page";
import Customers from "../pages/admin/customers/page";
import Employees from "../pages/admin/employees/page";
import Payrolls from "../pages/admin/payrolls/page";
import Suppliers from "../pages/admin/suppliers/page";
import Profits from "../pages/admin/profits/page";
import ImagesPage from "../pages/admin/images/page";
import ChangePassword from "../pages/admin/change-password/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <Dashboard />,
  },
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/admin/sales",
    element: <Sales />,
  },
  {
    path: "/admin/expenses",
    element: <Expenses />,
  },
  {
    path: "/admin/profits",
    element: <Profits />,
  },
  {
    path: "/admin/customers",
    element: <Customers />,
  },
  {
    path: "/admin/employees",
    element: <Employees />,
  },
  {
    path: "/admin/payrolls",
    element: <Payrolls />,
  },
  {
    path: "/admin/suppliers",
    element: <Suppliers />,
  },
  {
    path: "/admin/images",
    element: <ImagesPage />,
  },
  {
    path: "/admin/change-password",
    element: <ChangePassword />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;